import React, { Component } from "react";

import {
  CCard,
  CCardBody,
  CCardHeader,
  CSpinner,
  CButton
} from "@coreui/react";
import { connect } from "react-redux";
import { Prompt } from "react-router-dom";
import { bindActionCreators } from "redux";

import { logout } from "../../../../actions/baseActions";
import { setObj } from "../../../../actions/noteActions";
import Breadcrumb from "../../../../components/Breadcrumb";
import CommunityUsersSelector from "../../../../components/CommunityUsersSelector";
import ProtectedRoute from "../../../../components/ProtectedRoute";
import URL from "../../../../config/api";
import axios from "../../../../config/axios";

class RoomMembers extends Component {
  constructor(props) {
    super(props);

    this.state = {
      // loading: null,
      selectedUsers: [],
      creating: false
    };
  }

  insert() {
    this.setState({ creating: true });

    const date = new Date();
    const dateStr = `${date.getFullYear()}-${`00${date.getMonth() + 1}`.slice(
      -2
    )}-${`00${date.getDate()}`.slice(-2)} ${`00${date.getHours()}`.slice(
      -2
    )}:${`00${date.getMinutes()}`.slice(-2)}:${`00${date.getSeconds()}`.slice(
      -2
    )}`;

    const obj = this.state.selectedUsers.map(user => ({
      room_id: parseInt(this.props.match.params.id),
      user_id: user.id,
      administrator: !!user.administrator,
      start: dateStr,
      authorized: true,
      request: false,
      disciplines: user.disciplines ? user.disciplines : null
    }));

    axios
      .post(
        `${URL.api}community/room_user/insertMany`,
        { data: obj },
        { headers: { Authorization: `Bearer ${this.props.user.token}` } }
      )
      .then(
        resp => {
          this.props.history.push("/room/list");

          this.setState({ creating: false });
        },
        () => {
          this.error("Não foi possível inserir os usuários");
          this.setState({ creating: false });
        }
      );
  }

  componentDidMount() {
    this.props.setObj(16, this.props.currentRoute, this.props.currentRoute);
  }

  render() {
    const { id } = this.props.match.params;

    return (
      <>
        <Breadcrumb
          current={this.props.currentRoute}
          items={[{ path: "/room/list", to: "/room/list" }]}
        />
        <CCard>
          <Prompt
            when={!this.state.creating}
            message="Os dados do formulário ainda não foram salvos. Tem certeza de que deseja sair desta página?"
          />
          <CCardHeader className="d-flex align-items-center">
            <div style={{ display: "flex", flexDirection: "column", flex: 1 }}>
              <h4 className="card-title mb-1">Editar membros da comunidade</h4>
              <div className="small text-muted">
                Veja e edite os membros dessa comunidade
              </div>
            </div>
            <CButton
              color="primary"
              className="d-flex justify-content-center align-items-center"
              onClick={() => this.insert()}
              disabled={this.state.creating}
            >
              <>
                <span style={this.state.creating ? { opacity: 0 } : null}>
                  <i className="fa fa-cloud-upload mr-2"></i>Salvar
                </span>
                {this.state.creating && (
                  <CSpinner
                    size="sm"
                    color="white"
                    style={{ position: "absolute" }}
                  />
                )}
              </>
            </CButton>
          </CCardHeader>
          <CCardBody className="p-0">
            <CommunityUsersSelector
              onChange={e => this.setState({ selectedUsers: e })}
              id={id}
              isRoom
            />
          </CCardBody>
        </CCard>
        <ProtectedRoute routeId={this.props.currentRoute} />
      </>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout,
      setObj
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(RoomMembers);
